export default {
  // 地标图 气泡图 关系图 类型区域图 path 路径段热力图 柱图 轨迹图 热图
  // 地图关卡名称名称 FaDianZhan FaDianJiZu ShenZhenL3
  TGAL: {
    // 场景名称  //配置图层时layerConfig图层里面必须带有status字段
    // 所有主题在该关卡下所有的图层
    'TGAL-prot': {
      id: 'TGAL-prot',
      name: 'TGAL-prot',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-prot'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        layerType1: 'difLandmarkLayer',
        scatterType: 'prot',
        apiURL: '',
        coordZ: 43000,
        jsonPath: './data/all/Port.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'TGAL-pier': {
      id: 'TGAL-pier',
      name: 'TGAL-pier',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-pier'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'pier',
        apiURL: '',
        coordZ: 43000,
        jsonPath: './data/all/码头.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'TGAL-throughputBar': {
      id: 'TGAL-throughputBar', // 图层对象 id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      name: 'TGAL-throughputBar', // 图层名称，支持为图层自定义名称
      coordType: 0,
      coordTypeZ: 0,
      coordZ: 0,
      columnType: 'cube',
      columnMinHeight: 1,
      columnMaxHeight: 450000,
      columnAlpha: 1,
      columnPaint: 'linear',
      columnGap: 0,
      columnWidth: 30000,
      colorMax: '#ff0000',
      colorMin: '#ffff00',
      legends: [
        {
          name: 'legendName1',
          minValue: 1,
          maxValue: 10000,
          color: '#2BCAFF'
        }
      ],
      valueMax: 50,
      valueMin: 1,
      labelColor: '#ffffff',
      labelBackgroundColor: '#333333',
      data: [],
      isRemove: true,
      layerConfig: {
        layerType: '3DColumnLayer',
        scatterType: 'throughput',
        isInfoPanel: false,
        isTopNum: true,
        jsonPath: './data/all/throughputBar.json',
        apiURL: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'TGAL-logisticsSource': {
      id: 'TGAL-logisticsSource', // 图层对象 id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      name: 'TGAL-logisticsSource', // 图层名称，支持为图层自定义名称
      coordType: 0,
      coordTypeZ: 0,
      isShowBubble: true,
      bubbleRadiusMax: 40000,
      bubbleRadiusMin: 40000,
      bubbleSpeed: 25000,
      lineWidthMax: 20000,
      lineWidthMin: 20000,
      lineSpeed: 30000,
      curvature: 0.8,
      valueMax: 100,
      valueMin: 10,
      visible: true,
      legends: [
        {
          name: 'default',
          type: 'arrow',
          bubbleColor: '#2DB200',
          lineColor: '#2DB200',
          labelColor: '#ffffff',
          labelBackgroundColor: '#333333',
          labelFontSize: 20
        }
      ],
      data: [],
      layerConfig: {
        layerType: 'ODLineLayer',
        scatterType: 'logisticsSource',
        isInfoPanel: false,
        isTopNum: true,
        jsonPath: './data/all/物流来源.json',
        apiURL: '',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    }
  },
  'GK-GangKou': {
    'GK-GangKou-car': {
      id: 'GK-GangKou-car',
      name: 'GK-GangKou-car',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-car'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'car',
        apiURL: '',
        jsonPath: './data/portSituation/Car.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'GK-GangKou-person': {
      id: 'GK-GangKou-person',
      name: 'GK-GangKou-person',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-person'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'person',
        apiURL: '',
        jsonPath: './data/portSituation/Person.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'GK-GangKou-ship': {
      id: 'GK-GangKou-ship',
      name: 'GK-GangKou-ship',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-ship'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'ship',
        apiURL: '',
        jsonPath: './data/portSituation/ship.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'GK-GangKou-camera': {
      id: 'GK-GangKou-camera',
      name: 'GK-GangKou-camera',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-camera'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'camera',
        apiURL: '',
        jsonPath: './data/maritimeSafety/camera.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'GK-GangKou-event': {
      id: "GK-GangKou-event",
      name: "GK-GangKou-event",
      coordType: 0,
      coordTypeZ: 2,
      visible: true,
      legends: [{
        name: "default",
        icon: "custom-event",
        type: "wave",
        color: "#ff0000",
        fillArea: "type01",
        speed: 15,
        radius: 30
      }],
      data: [],
      layerConfig: {
        layerType: 'eventLayer',
        scatterType: 'event',
        apiURL: '',
        jsonPath: './data/maritimeSafety/event.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {}, // 添加时候的数据
      }
    },
    'GK-GangKou-path': {
      id: 'GK-GangKou-path',
      name: 'GK-GangKou-path',
      coordType: 0,
      coordTypeZ: 2,
      type: "Arrow05",
      color: "#00ff00",
      colorPass: "#00ff00",
      width: 30,
      textureSpeed: 5,
      layerConfig: {
        layerType: 'path',
        scatterType: 'path',
        jsonPath: './data/maritimeSafety/path.json',
        status: 'none', // 显示状态 none show hide
      }
    },
    'GK-GangKou-BridgeCrane': {
      id: 'GK-GangKou-BridgeCrane',
      name: 'GK-GangKou-BridgeCrane',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-BridgeCrane'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'BridgeCrane',
        apiURL: '',
        jsonPath: './data/terminalOperations/BridgeCrane.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'GK-GangKou-Container': {
      id: 'GK-GangKou-Container',
      name: 'GK-GangKou-Container',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-Container'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'Container',
        apiURL: '',
        jsonPath: './data/terminalOperations/Container.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
    'GK-GangKou-GantryCrane': {
      id: 'GK-GangKou-GantryCrane',
      name: 'GK-GangKou-GantryCrane',
      legends: [
        {
          name: 'default',
          color: '#ffff',
          iconName: 'custom-GantryCrane'
        }
      ],
      layerConfig: {
        layerType: 'landmarkLayer',
        scatterType: 'GantryCrane',
        apiURL: '',
        jsonPath: './data/terminalOperations/GantryCrane.json',
        isClick: true,
        status: 'none', // 显示状态 none show hide
        rawData: [], // 原始数据
        jsonData: {} // 添加时候的数据
      }
    },
  },

  defaultLayers: {
    FaDianZhan: {},
    FaDianJiZu: {}
  }
};
